import VisibleComponent from '../VisibleComponent'
import './index.less'

const template = `
  <div class = "video-inner-container">
    <video
      class = "video-player"
      webkit-playsinline
      playsinline
      x-webkit-airplay="allow"
      x5-playsinline
      x5-video-player-type="h5"
      x5-video-player-fullscreen
    >
    </video>
  </div>
`

/**
 * Video类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Video extends VisibleComponent {
  constructor(options = {}) {
    super(options)
    this.template = template
    this.onTimeUpdateSecondFuncArray = null
    this.lastSendSecond = -1
    this.init(options)
  }

  init(options) {
    super.init(options)
    const {
      vid = '',
      src = '',
      autoplay = true,
      mute = false,
      preview = 'image',
      previewSrc = '',
      speed = 1,
      controls = false,
      cssText = {
        'object-fit': 'contain',
      },
      preload = true,
    } = options

    const videoEl = this.element.querySelector('video')
    videoEl.src = src
    if (vid) {
      videoEl.id = vid
    }
    videoEl.style.cssText += this.changeObjToString(cssText)
    if (preview == 'image') {
      videoEl.poster = previewSrc
    } else if (previewSrc) {
      videoEl.addEventListener('loadeddata', function () {
        let canvas = document.createElement("canvas"),
            width = videoEl.width, //canvas的尺寸和图片一样
            height = videoEl.height
        canvas.width = width
        canvas.height = height
        canvas.getContext("2d").drawImage(videoEl, 0, 0, width, height) //绘制canvas
        dataURL = canvas.toDataURL('image/jpeg') //转换为base64
        videoEl.poster = dataURL
      })
    }
    videoEl.autoplay = autoplay
    videoEl.preload = preload
    videoEl.controls = controls
    videoEl.muted = mute
    videoEl.volume = mute ? 1 : 0
    videoEl.playbackRate = speed
  }

  /**
   * 将对象转化成字符串 
   * @description ex: {a:1,b:2} => "a:1 b:2"
   * @param  {Object} obj 对象
   * @return {String} 字段字符串
   */
  changeObjToString(obj) {
    let ret = ''
    if ('object' == typeof obj && obj) {
      Object.keys(obj).forEach((key) => {
        ret += `${key}: ${obj[key]};`
      })
    }
    return ret
  }
  mountTo(el, pos = 'beforeend') {
    el.insertAdjacentElement(pos, this.element)
  }
  unmount() {
    this.element.parentNode.removeChild(this.element)
    this.destory()
  }
  play() {
    this.element.querySelector('video').play()
  }
  pause() {
    this.element.querySelector('video').pause()
  }
  resume() {
    this.element.querySelector('video').play()
  }
  stop() {
    this.element.querySelector('video').load()
  }
  mute() {
    this.element.querySelector('video').muted = true
    this.element.querySelector('video').volume = 0
  }
  unmute() {
    this.element.querySelector('video').muted = false
    this.element.querySelector('video').volume = 1
  }
  setSpeed(speed) {
    this.element.querySelector('video').playbackRate = speed
  }
  setSrc(src) {
    this.element.querySelector('video').src = src
  }
  appendTo(el) {
    this.mountTo(el)
  }
  /**
   * 是否静音
   * @returns {boolean}
   */
  isMute() {
    return this.element.querySelector('video').muted
  }
  /**
   * 是否非静音
   * @returns {boolean}
   */
  isUnmute() {
    return !this.element.querySelector('video').muted
  }
  getVideoAttribute(attrName = '') {
    let ret = ''
    if (attrName) {
      ret = this.element.querySelector('video')[attrName]
    }
    return ret
  }
  bindVideoEvent(name, func) {
    this.element.querySelector('video').addEventListener(name, func, false)
  }
  onPause(func) {
    this.bindVideoEvent('pause', func)
  }
  onPlay(func) {
    this.bindVideoEvent('play', func)
  }
  /**
   * 绑定函数到视频时间改变时，秒级精度
   * @param {Function} cusFunction 
   */
  onVideoTimeUpdateWithSecondAccu(func) {
    if (this.onTimeUpdateSecondFuncArray == null) {
      this.onTimeUpdateSecondFuncArray = []
      this.bindVideoEvent('timeupdate', () => {
        const currentTime = Math.floor(this.element.querySelector('video').currentTime)
        if (this.lastSendSecond != currentTime) {
          this.lastSendSecond = currentTime
          this.onTimeUpdateSecondFuncArray.forEach((cusFunc) => {
            cusFunc()
          })
        }
      })
    }
    this.onTimeUpdateSecondFuncArray.push(func)
  }
  /**
    * 切换播放状态
    * @returns {*|Promise<any>}
  */
  togglePlay(){
    let ret
    if (this.element.querySelector('video').paused) {
      ret = this.play()
    } else {
      ret = this.pause()
    }
    return ret
  }
  /**
    * 切换静音状态
    * @returns {*|Promise<any>}
  */
  toggleMute(){
    let ret
    if (this.element.querySelector('video').muted) {
      ret = this.unmute()
    } else {
      ret = this.mute()
    }
    return ret
  }
}

export default Video